import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { once as T } from '../../../utils/once.js';
import { disposables as g } from '../../../utils/disposables.js';
import { match as s } from '../../../utils/match.js';

function d(t) {
  var _t$classList;

  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }

  t && e.length > 0 && (_t$classList = t.classList).add.apply(_t$classList, e);
}

function v(t) {
  var _t$classList2;

  for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    e[_key2 - 1] = arguments[_key2];
  }

  t && e.length > 0 && (_t$classList2 = t.classList).remove.apply(_t$classList2, e);
}

function F(t, e) {
  var n = g();
  if (!t) return n.dispose;

  var _getComputedStyle = getComputedStyle(t),
      m = _getComputedStyle.transitionDuration,
      o = _getComputedStyle.transitionDelay,
      _map = [m, o].map(function (a) {
    var _a$split$filter$map$s = a.split(",").filter(Boolean).map(function (i) {
      return i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3;
    }).sort(function (i, f) {
      return f - i;
    }),
        _a$split$filter$map$s2 = _slicedToArray(_a$split$filter$map$s, 1),
        _a$split$filter$map$s3 = _a$split$filter$map$s2[0],
        r = _a$split$filter$map$s3 === void 0 ? 0 : _a$split$filter$map$s3;

    return r;
  }),
      _map2 = _slicedToArray(_map, 2),
      u = _map2[0],
      p = _map2[1],
      l = u + p;

  if (l !== 0) {
    n.group(function (r) {
      r.setTimeout(function () {
        e(), r.dispose();
      }, l), r.addEventListener(t, "transitionrun", function (i) {
        i.target === i.currentTarget && r.dispose();
      });
    });
    var a = n.addEventListener(t, "transitionend", function (r) {
      r.target === r.currentTarget && (e(), a());
    });
  } else e();

  return n.add(function () {
    return e();
  }), n.dispose;
}

function y(t, e, n, m) {
  var o = n ? "enter" : "leave",
      u = g(),
      p = m !== void 0 ? T(m) : function () {};
  o === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
  var l = s(o, {
    enter: function enter() {
      return e.enter;
    },
    leave: function leave() {
      return e.leave;
    }
  }),
      a = s(o, {
    enter: function enter() {
      return e.enterTo;
    },
    leave: function leave() {
      return e.leaveTo;
    }
  }),
      r = s(o, {
    enter: function enter() {
      return e.enterFrom;
    },
    leave: function leave() {
      return e.leaveFrom;
    }
  });
  return v.apply(void 0, [t].concat(_toConsumableArray(e.enter), _toConsumableArray(e.enterTo), _toConsumableArray(e.enterFrom), _toConsumableArray(e.leave), _toConsumableArray(e.leaveFrom), _toConsumableArray(e.leaveTo), _toConsumableArray(e.entered))), d.apply(void 0, [t].concat(_toConsumableArray(l), _toConsumableArray(r))), u.nextFrame(function () {
    v.apply(void 0, [t].concat(_toConsumableArray(r))), d.apply(void 0, [t].concat(_toConsumableArray(a))), F(t, function () {
      return v.apply(void 0, [t].concat(_toConsumableArray(l))), d.apply(void 0, [t].concat(_toConsumableArray(e.entered))), p();
    });
  }), u.dispose;
}

export { y as transition };